export enum UiMode {
  VIEW = 'view',
  CODE = 'code',
}
